import React, { useEffect, useState } from 'react'
import './app-menu.scss'

export const NavLink = ({
  className,
  href,
  children,
  id,
  onClick,
}: {
  className: string
  href: string
  children: React.ReactNode
  id?: string
  onClick: () => void
}) => {
  return (
    <li className={'f-app-menu__list__item ' + className}>
      <a
        onClick={onClick}
        href={href}
        data-tag="6A"
        className="f-button --btn-url"
        id={id}
      >
        {children}
      </a>
    </li>
  )
}

const AppMenu = ({ links }: { links: Record<string,string> }) => {
  if (!links) {
    links = { inicio: '/' }
  }
  const [hash, setHash] = useState('')
  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }
    const onHashListener = () => {
      setHash(window.location.hash)
      if (window.location.hash.length === 0) {
        return
      }
      let element: HTMLElement | null = document.querySelector(
        window.location.hash
      )
      if (element) {
        document?.scrollingElement?.scroll(0, element.offsetTop - 60)
      }
    }
    window.addEventListener('hashchange', onHashListener, false)
    onHashListener()
    return () => {
      window.removeEventListener('hashchange', onHashListener)
    }
  }, [])
  return (
    <nav className="f-app-menu ">
      <ul className="f-app-menu__list">
        {Object.keys(links).map(key => {
          return (
            <NavLink
              className={hash === '#' + key ? ' --active' : ''}
              href={'#' + key}
              key={key}
              onClick={() => {}}
            >
              {links[key]}
            </NavLink>
          )
        })}
      </ul>
    </nav>
  )
}

export default AppMenu
